export const environment = {
    production: false,
    cognitoUserPoolId: "ap-southeast-2_8JDxpBmE7",
    cognitoAppClientId: "5rk0b6436dfehprta1ml2vs0qo",
    apiUrl: "https://iou-api-dev.sempre.gen.nz"
};
